export default __webpack_public_path__ + "static/media/wquantity.b63db878.png";